import { useCallback, useEffect } from "react";

type RefreshFunction = () => Promise<void>;

interface UseTokenRefreshOptions {
  interval?: number;
  refreshOnMount?: boolean;
  onError?: (error: unknown) => void;
  disabled?: boolean;
}

export const useTokenRefresh = (
  onRefresh: RefreshFunction,
  {
    interval = 5 * 60 * 1000,
    refreshOnMount = true,
    onError = () => console.error("Token refresh failed"),
    disabled = false,
  }: UseTokenRefreshOptions = {},
) => {
  const refreshToken = useCallback(async () => {
    try {
      !disabled && (await onRefresh());
    } catch (error) {
      onError(error);
    }
  }, [onRefresh, onError, disabled]);

  useEffect(() => {
    if (refreshOnMount) {
      refreshToken();
    }

    const intervalId = setInterval(refreshToken, interval);

    return () => clearInterval(intervalId);
  }, [refreshToken, interval, refreshOnMount]);

  return {
    refresh: refreshToken,
  };
};
